import { map } from "lodash-es";
export function getErrorMessage(errorResponse: { errors: { detail: string }[] } | null) {
  let errorMessage = ["An error occured."];
  if ((errorResponse?.errors ?? []).length > 0) {
    errorMessage = map(errorResponse?.errors, (error) => error.detail ?? "");
    return errorMessage;
  } else {
    return errorMessage;
  }
}
